import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { push } from 'react-router-redux';

import * as abonadosActions from 'modules/abonados/action';
import * as generalActions from 'modules/general/action';

import ItemListC from './itemList';

@connect(store => ({
  abonadosList: store.getIn(['abonados', 'lista', 0]) || [],
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('Roles'));
  };
  add = () => this.props.dispatch(push('/dashboard/abonados/add/new'));
  buscarAbonados = e => {
    if (e.target.value.length > 2) this.props.dispatch(abonadosActions.get(e.target.value));
    else this.props.dispatch(abonadosActions.clear('lista'));
  };
  render() {
    const { abonadosList } = this.props;
    return (
      <div>
        <Row className="rowContainer">
          <Col md={{ size: 6, offset: 3 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <Row>
                <Col md={1}>
                  <FontAwesome name="search" className="pt-30" size="2x" />
                </Col>
                <Col md={11}>
                  <MaterialUI.TextField hintText="Nombre, apellido, DNI o email" floatingLabelText="Buscar" fullWidth={true} name="queryAbonado" onChange={this.buscarAbonados} />
                </Col>
              </Row>

              <MaterialUI.List className="noPadding dividerList">
                {abonadosList.map(abonado => (
                  <ItemListC abonado={abonado} key={abonado.get('id')} />
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/roles/components/main.js